import * as React from 'react';
import ProductCompareRepository from "../../repository/ProductCompareRepository";
import { useSelector } from "react-redux";
import { Tooltip } from "../Tooltip";
import liveAuth from 'src/helper/liveAuth';
import useCheckAuthPermissions from 'src/hooks/component/useCheckAuthPermissions';
import System from 'src/helper/system';
import RoleAndPermission from 'src/helper/RoleAndPermission';


const ProductCompareSelection = (props) => {
    const { single_product } = props;
    const model_ProductCompare_data = useSelector((state) => state.entities.model_ProductCompare.data);
    const status = (single_product && model_ProductCompare_data && model_ProductCompare_data[single_product.ItemNumber] !== undefined && model_ProductCompare_data[single_product.ItemNumber]) ? true : false;
    const [_check_p] = useCheckAuthPermissions();

    const inputRender = (isOnChange = true) => {
        let checkbox = isOnChange ?
            <input type="checkbox"
                onChange={() => { validateCompareSelection() }}
                checked={status}
                className="form-check-input"
                id={'compare' + single_product.ItemNumber}
            />
            :
            <input type="checkbox"
                checked={status}
                className="form-check-input"
            />
        return checkbox
    };
    const isGuestFullRights = () => {
        return (_check_p('PDG_ADD_TO_CART').status &&
            _check_p('PDG_ADD_TO_BOM').status &&
            _check_p('PDG_CLICK_TO_QUOTE').status);
    }

    /**  10195 - validate login and show contact us if fails to validate - Pankaj - 20 April 2023      */
    const validateCompareSelection = async () => {
        if (!liveAuth.check()) {
            System.popup('GuestPopupActionButton', { title: 'Compare Products', body: 'Sign-in to compare products.', alignCenter: true })
            return false;
        } else {
            let res = await new ProductCompareRepository().toggleSingleProduct(single_product)
            // new BroadcastChannel('product-compare-toggled').postMessage({}); // 13546
            await new ProductCompareRepository().fetchAllData();
            return true;
        }
    }

    const isAuthAccountLess = () => {
        return _check_p('PD_ADD_TO_BOM').status === true
    }

    return (
        <>
            {single_product &&
                (!liveAuth.check() || (liveAuth.check() && isGuestFullRights()) || isAuthAccountLess()) &&
                <section className="form-check sm-custom_checkbox">
                    {status === false && Object.entries(model_ProductCompare_data).length > 9 ?
                        <Tooltip
                            position={'right center'}
                            opener={() => (inputRender(false))}
                            content={() => (
                                <div>
                                    Part cannot be added. Product compare is limited to 10 parts.
                                </div>
                            )}
                        /> :
                        inputRender()
                    }
                    <label className="form-check-label"
                        htmlFor={'compare' + single_product.ItemNumber}>Compare</label>
                </section>
            }
            {single_product &&
                liveAuth.check() && isGuestFullRights() === false && !isAuthAccountLess() &&
                <Tooltip
                    position={'bottom center'}
                    opener={() => (
                        <section
                            className="form-check sm-custom_checkbox btn-unauthorize">
                            <input type="checkbox"
                                className="form-check-input"
                                id={'compare' + single_product.ItemNumber}
                                onClick={(e) => e.preventDefault()} />

                            <label className="form-check-label"
                                htmlFor={'compare' + single_product.ItemNumber}>Compare</label>
                        </section>
                    )}
                    content={() => (
                        <>
                            <div dangerouslySetInnerHTML={{ __html: RoleAndPermission.getGuestErrorForBOMCart() }}>
                            </div>
                        </>
                    )} />
            }
        </>
    );
}

export default ProductCompareSelection;